import Icon1 from "@assets/icons/Icon";
import theme from "@theme/index";
import { CSSProperties, JSX, use, useState } from "react";
import { useEffect, useRef } from "react";

interface ButtonProps {
  label: string;
  onClick?: () => void;
  style?: CSSProperties;
  variant?: "small" | "medium" | "large";
  disabled?: boolean;
  children?: JSX.Element | JSX.Element[];
}

export default function MenuButton({
  label,
  onClick,
  style,
  variant = "medium",
  disabled = false,
  children,
}: ButtonProps) {
  const [open, setOpen] = useState<boolean>(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState<boolean>(false);
  // Close on click outside
  useEffect(() => {
    if (!open) return;

    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  useEffect(() => {
    if (open) {
      setVisible(true);
    } else {
      const timeout = setTimeout(() => setVisible(false), 200);
      return () => clearTimeout(timeout);
    }
  }, [open]);
  return (
    <div className="relative h-fit " ref={menuRef}>
      <div
        onClick={() => setOpen(!open)}
        className={`   
          hover:ring-2 hover:ring-neutral-300 

         w-fit rounded-xl shadow-md 
        ${disabled ? "bg-neutral-300 text-neutral-500 cursor-not-allowed" : "bg-black text-white cursor-pointer"} flex flex-row items-center justify-center`}
      >
        <div className="w-fit px-6 py-3 font-medium text-h2">{label}</div>
        <div className="self-stretch border-r-1 border-neutral-400"></div>
        <div className="p-3 flex flex-col justify-center items-center">
          <Icon1 name="down" size={16} color="white" />
        </div>
      </div>

      {open && (
        <div
          className={`
          ${visible ? "opacity-100 translate-y-0 scale-100" : "opacity-0 translate-y-10 scale-90"}
        absolute top-full left-0 z-50 w-300 transition-all duration-200 flex flex-col text-shadow_50 border-1 border-shadow_10 bg-white  shadow-xl rounded-lg`}
        >
          {children}
        </div>
      )}
    </div>
  );
}
